import { useMemo } from 'react';
import { createTrialExitFeedbackTransport, useTrialExitFeedback } from '@overlayqa/shared/ui';
import { useAuth, useUser } from '@/lib/auth';
import { apiBaseUrl } from '@/lib/apiBaseUrl';
import { useAppSession } from './useAppSession';
import { useProject } from './useProjects';

/** The streamed review uses the same account claim as every capture surface. */
export function useDraftExitFeedback(projectId: string | undefined) {
  const { getToken, isSignedIn } = useAuth();
  const { user } = useUser();
  const { data: session } = useAppSession();
  const { data: project } = useProject(projectId ?? '');
  // The token follows Clerk immediately; cached bootstrap data must name that
  // same identity before it can label a claim or an answer.
  const accountId = isSignedIn && user?.id && session?.user.clerkId === user.id ? session.user.id : null;
  const transport = useMemo(() => createTrialExitFeedbackTransport({ apiOrigin: apiBaseUrl(), getToken }), [getToken]);
  return useTrialExitFeedback({
    accountId,
    teamId: project?.teamId ?? null,
    transport,
    enabled: !!accountId && !!project?.role && project.role !== 'viewer',
  });
}
